import { Badge, Icon, Image, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { constants } from '@hero/configs';
import { useCreatePriceLabel } from '@hero/hooks';

import * as S from './style';

function ProductDetailInfo({ product }) {
  const { t } = useTranslation();

  const { priceLabel, regularPriceLabel } = useCreatePriceLabel(product);

  return (
    <>
      <S.ProductCardBrand>
        {constants?.brands?.data[product.brand?.id]?.logo && (
          <S.ProductCardBrandInnerWrapper>
            <S.ProductCardBrandImage>
              <Image
                src={product?.meta?.logoUrl || constants?.brands?.data[product.brand?.id]?.logo}
                alt={product.name}
                height={16}
              />
            </S.ProductCardBrandImage>
            {!product.orderable && (
              <S.ProductStockWrapper>
                <Badge variant="contained" color="warningWeak" text={t('outOfStock')} size="sm" />
              </S.ProductStockWrapper>
            )}
          </S.ProductCardBrandInnerWrapper>
        )}
        <S.ProductCardBrandCode>
          <S.ProductCardBrandCodeSpan>{t('code')}:</S.ProductCardBrandCodeSpan>
          {product.merchantProductId}
        </S.ProductCardBrandCode>
      </S.ProductCardBrand>
      <Typography variant="h3">
        <div dangerouslySetInnerHTML={{ __html: product.name }} />
      </Typography>
      <S.ProductPriceWrapper>
        <Typography variant="subtitle3Bold" emphasis="weaker">
          {priceLabel}
        </Typography>
        {regularPriceLabel && (
          <Typography
            variant="body2"
            color="fg"
            style={{ marginLeft: 8, textDecoration: 'line-through' }}
          >
            {regularPriceLabel}
          </Typography>
        )}
      </S.ProductPriceWrapper>
      {product?.meta?.isInternational && (
        <S.EGiftCardInternationalText variant="body2Italic" color="fg">
          <Icon name="globe" />
          {t('eGiftCardInternationalText')}
        </S.EGiftCardInternationalText>
      )}
    </>
  );
}

ProductDetailInfo.props = {
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    orderable: PropTypes.bool,
    merchantProductId: PropTypes.string
  })
};

export { ProductDetailInfo };
